import React from 'react';

import mainImage from '../../../../assets/HomePage/Montage.png';
import ImageGrid from '../../../UI/ImageGrid/ImageGrid';

import { Typography, Box, Grid } from '@mui/material';

const Headline = () => {
  return (
    <Box
      sx={{
        width: { xs: '90%', sm: '80%', xl: '65%' },
        mx: 'auto',
        maxWidth: '1200px',
      }}>
      <Grid
        container
        spacing={6}
        sx={{
          mt: '1rem',
        }}
        direction='row'
        justifyContent='center'
        alignItems='center'>
        <Grid item lg={6}>
          <Typography variant='h4' component='h2' sx={{ fontWeight: 'bold' }}>
            Starting a company is lonely.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1.2rem' }}>
            You have to make difficult decisions every day with imperfect information on problems you’ve likely never
            faced before. It’s daunting.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1.2rem' }}>
            In our experience, the best way to overcome the challenges is to learn from the wins and mistakes of others,
            and to surround yourself with founders who’ve been there, done that.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1.2rem' }}>
            Whether you’re in the thick of it in Choa Chu Kang or Changi, finding your people is tough.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1.2rem' }}>
            But when you do find them, it’s life changing.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1.2rem' }}>
            And that’s what The 100 Club is for.
          </Typography>
          <Typography variant='body1' sx={{ mt: '1.2rem' }}>
            Joining The 100 Club gives you immediate access to a tribe of founders and entrepreneurs who are going
            through the same things as you. Members consistently call it “life changing”.
          </Typography>
        </Grid>
        <ImageGrid gridSize={6} src={mainImage} alt={'introduction'} maxWidth={{ maxWidth: '100%' }} />
      </Grid>
    </Box>
  );
};

export default Headline;
